import configs from '~/configs';
import { Card, Col, Row, Button } from 'antd';
import React, { useState, useEffect } from 'react';
import ClaimFailModal from './ClaimFailModal';
import { ClaimButton } from './ClaimButton';
import { useSDK } from '@metamask/sdk-react';
import { useDispatch, useSelector } from 'react-redux'
import { getClaimDetail, claimMonsterHashRank } from '~/views/redux/actions/monster'

export const InfoHash = (props) => {
  const { t, monsterDetail, actions, addressWallet } = props;
  const [isClaimFailModalOpen, setIsClaimFailModalOpen] = React.useState(false);
  const [claimingRanks, setClaimingRanks] = useState(new Set()); 
  const { sdk } = useSDK(); 

const handleClaim = (tokenId, rank) => {
  setClaimingRanks((prev) => new Set(prev).add(rank));
  
  actions.claimMonsterHashRank({
    tokenId,
    rank,
    sdk,
    onSuccess: () => {
      actions.getMonsterHashDetail({
        tokenId: tokenId,
        contract: monsterDetail?.contractAddress,
        wallet: addressWallet, 
        onSuccess: () => {
          setClaimingRanks((prev) => {
            const newSet = new Set(prev);
            newSet.delete(rank);
            return newSet;
          });
        },
        onError: () => {
          setClaimingRanks((prev) => {
            const newSet = new Set(prev);
            newSet.delete(rank);
            return newSet;
          });
        },
      });
    },
    onError: () => {
      setIsClaimFailModalOpen(true);
      setClaimingRanks((prev) => {
        const newSet = new Set(prev);
        newSet.delete(rank);
        return newSet;
      });
    },
  });
};
  const traitTypes = [
    'Mint',
    'Monster Rank E', 'Monster Rank D', 'Monster Rank C', 'Monster Rank B', 'Monster Rank A',
    'Monster Regeneration 1', 'Monster Regeneration 2', 'Monster Regeneration 3',
    'Monster Fusion 1', 'Monster Fusion 2',
    'Coach 1', 'Coach 2',
    'Crystallization 1', 'Crystallization 2',
    'Ranked Match 1', 'Ranked Match 5', 'Ranked Match 10',
    'Exploration 1', 'Exploration 5', 'Exploration 10',
  ];

  useEffect(() => {
    if (monsterDetail && claimingRanks.size > 0) {
      const updatedRanks = new Set(claimingRanks);
      let hasChanges = false;
      traitTypes.forEach((trait) => {
        const rank = traitTypes.indexOf(trait) - 1;
        if (monsterDetail?.claims?.[rank]?.[1]) {
          if (updatedRanks.has(rank)) {
            updatedRanks.delete(rank);
            hasChanges = true;
          }
        }
      });
      if (hasChanges) {
        setClaimingRanks(updatedRanks);
      }
    }
  }, [monsterDetail, claimingRanks]);

  const handleCancel = () => {
    setIsClaimFailModalOpen(false);
  };

  const attributeMap = traitTypes.reduce((acc, trait) => {
    const attr = monsterDetail?.attributes?.find((a) => a.trait_type === trait);
    const rank = traitTypes.indexOf(trait) - 1;
    const isClaimed = monsterDetail?.claims?.[rank]?.[1];
    if (isClaimed) {
      return {
        ...acc,
        [trait]: {
          status: 'Claimed',
          value: 0,
        },
      };
    }
    return {
      ...acc,
      [trait]: {
        status: attr?.status ?? 'Unavailable',
        value: attr?.value ?? null,
      },
    };
  }, {});

  const getRank = (traitType) => {
    return traitTypes.indexOf(traitType) - 1;
  };

  const isOwner = addressWallet && monsterDetail?.owner_address && addressWallet.toLowerCase() === monsterDetail.owner_address.toLowerCase();

  const parseDescription = (description) => {
    if (!description) return 'N/A';
    const urlRegex = /URL:\s*(https?:\/\/[^\s]+)/g;
    const formattedDescription = description.replace(
      urlRegex,
      (_, url) =>
        `<br/><span style="color: white;">URL:</span> <a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #40A9FF;">${url}</a>`
    );
    return formattedDescription;
  };

  const descriptionContent = parseDescription(monsterDetail?.description);

  const getRegenerationColor = (type, count) => {
    if (type === 'Genesis Hash') {
      if (count <= 1) return 'white';
      if (count <= 3) return '#FFD700';
      return '#FF4D4F';
    } else {
      if (count === 0) return 'white';
      if (count === 1) return '#FFD700';
      return '#FF4D4F';
    }
  };

  const maxRegeneration = {
    'Genesis Hash': 5,
    'General Hash': 3,
    'Hash Chip NFT': 3,
  };

  const regenerationCount = monsterDetail?.timesRegeneration || 0;
  const remainingRegeneration = maxRegeneration[monsterDetail?.type_name] - regenerationCount;

  return (
    <Card className="w-full">
      {monsterDetail?.type_name === 'Hash Chip NFT' ? (
        <>
          <div className="grid grid-cols-2 gap-4">
            <div className="grid grid-cols-1 bg-[#020f38] py-[16px] px-[24px] min-h-[142px] rounded-[8px] font__M__plus font-bold">
              <Row className="items-start mb-2">
                <Col span={12} className="font__M__plus font-bold text-[16px]">
                  {t('hashNFTDetail.ID')}
                </Col>
                <Col span={12} className="font__M__plus font-medium text-end text-[16px]">
                  <a
                    style={{ color: '#40A9FF' }}
                    href={`${configs.NETWORK.scan}token/${monsterDetail?.contractAddress ?? configs.ADDRESS_HASHCHIP_OAS}/instance/${monsterDetail?.tokenId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {monsterDetail?.tokenId}
                  </a>
                </Col>
              </Row>
              {monsterDetail?.name && monsterDetail?.asset === 'HASH CHIP NFT' && (
                <Row className="items-start mb-2">
                  <Col span={12} className="font__M__plus font-bold text-[16px]">
                    {t('hashNFTDetail.name')}
                  </Col>
                  <Col span={12} className="font__M__plus font-medium text-end text-[16px]">
                    {monsterDetail?.name}
                  </Col>
                </Row>
              )}
              {monsterDetail?.description && (
                <Row className="items-start mb-2">
                  <Col span={12} className="font__M__plus font-bold text-[16px]">
                    {t('hashNFTDetail.description')}
                  </Col>
                  <Col span={12} className="font__M__plus font-medium text-end text-[16px] text-justify">
                    <div
                      className="text-justify break-words whitespace-pre-line"
                      dangerouslySetInnerHTML={{ __html: descriptionContent }}
                    />
                  </Col>
                </Row>
              )}
              <Row className="items-start mb-2">
                <Col span={12} className="font__M__plus font-bold text-[16px]">
                  {t('hashNFTDetail.regenerationCount')}
                </Col>
                <Col span={12} className="font__M__plus font-medium text-end text-[16px]">
                  <span style={{ color: getRegenerationColor(monsterDetail?.type_name, regenerationCount) }}>
                    {regenerationCount}/{maxRegeneration[monsterDetail?.type_name]}
                  </span>
                </Col>
              </Row>
              <Row className="items-start mb-2">
                <Col span={12} className="font__M__plus font-bold text-[16px]">
                  {t('hashNFTDetail.remainingRegeneration')}
                </Col>
                <Col span={12} className="font__M__plus font-medium text-end text-[16px]">
                  {remainingRegeneration}
                </Col>
              </Row>
              {monsterDetail?.main_seed && (
                <Row className="items-start mb-2">
                  <Col span={12} className="font__M__plus font-bold text-[16px]">
                    {t('hashNFTDetail.mainSeed')}
                  </Col>
                  <Col span={12} className="font__M__plus font-medium text-end text-[16px]">
                    {monsterDetail?.main_seed}
                  </Col>
                </Row>
              )}
              {monsterDetail?.mintType && (
                <Row className="items-start mb-2">
                  <Col span={12} className="font__M__plus font-bold text-[16px]">
                    {t('hashNFTDetail.mint')}
                  </Col>
                  <Col span={12} className="font__M__plus font-medium text-end text-[16px]">
                    {monsterDetail?.mintType}
                  </Col>
                </Row>
              )}
              <Row>
                <Col span={12} className="mb-3 text-[16px]">
                  {attributeMap['Monster Rank E']?.value !== null && (
                    <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_rank_e')}</div>
                  )}
                </Col>
                <Col span={12} className="mb-3 text-end flex justify-end items-center">
                  {attributeMap['Monster Rank E']?.value !== null && (
                    <div className="font__M__plus font-medium flex items-center w-full">
                      <div className="flex items-center gap-1 ml-auto">
                        <span className="status-text text-right pr-0">
                          {attributeMap['Monster Rank E']?.status === 'Claimable' ? (
                            isOwner ? (
                              <ClaimButton
                                onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Rank E'))}
                                disabled={claimingRanks.has(getRank('Monster Rank E'))}
                              />
                            ) : (
                              <span className="claimable">Claimable</span>
                            )
                          ) : (
                            <span>{attributeMap['Monster Rank E']?.status}</span>
                          )}
                        </span>
                        <span>|</span>
                        <span className="value-text text-left">
                          {attributeMap['Monster Rank E']?.value ?? 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={12} className="mb-3 text-[16px]">
                  {attributeMap['Monster Rank D']?.value !== null && (
                    <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_rank_d')}</div>
                  )}
                </Col>
                <Col span={12} className="mb-3 text-end flex justify-end items-center">
                  {attributeMap['Monster Rank D']?.value !== null && (
                    <div className="font__M__plus font-medium flex items-center w-full">
                      <div className="flex items-center gap-1 ml-auto">
                        <span className="status-text text-right pr-0">
                          {attributeMap['Monster Rank D']?.status === 'Claimable' ? (
                            isOwner ? (
                              <ClaimButton
                                onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Rank D'))}
                                disabled={claimingRanks.has(getRank('Monster Rank D'))}
                              />
                            ) : (
                              <span className="claimable">Claimable</span>
                            )
                          ) : (
                            <span>{attributeMap['Monster Rank D']?.status}</span>
                          )}
                        </span>
                        <span>|</span>
                        <span className="value-text text-left">
                          {attributeMap['Monster Rank D']?.value ?? 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={12} className="mb-3 text-[16px]">
                  {attributeMap['Monster Rank C']?.value !== null && (
                    <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_rank_c')}</div>
                  )}
                </Col>
                <Col span={12} className="mb-3 text-end flex justify-end items-center">
                  {attributeMap['Monster Rank C']?.value !== null && (
                    <div className="font__M__plus font-medium flex items-center w-full">
                      <div className="flex items-center gap-1 ml-auto">
                        <span className="status-text text-right pr-0">
                          {attributeMap['Monster Rank C']?.status === "Claimable" ? (
                            isOwner ? (
                              <ClaimButton
                                onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Rank C'))}
                                disabled={claimingRanks.has(getRank('Monster Rank C'))}
                              />
                            ) : (
                              <span className="claimable">Claimable</span>
                            )
                          ) : (
                            <span>{attributeMap['Monster Rank C']?.status}</span>
                          )}
                        </span>
                        <span>|</span>
                        <span className="value-text text-left">
                          {attributeMap['Monster Rank C']?.value ?? 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={12} className="mb-3 text-[16px]">
                  {attributeMap['Monster Rank B']?.value !== null && (
                    <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_rank_b')}</div>
                  )}
                </Col>
                <Col span={12} className="mb-3 text-end flex justify-end items-center">
                  {attributeMap['Monster Rank B']?.value !== null && (
                    <div className="font__M__plus font-medium flex items-center w-full">
                      <div className="flex items-center gap-1 ml-auto">
                        <span className="status-text text-right pr-0">
                          {attributeMap['Monster Rank B']?.status === "Claimable" ? (
                            isOwner ? (
                              <ClaimButton
                                onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Rank B'))}
                                disabled={claimingRanks.has(getRank('Monster Rank B'))}
                              />
                            ) : (
                              <span className="claimable">Claimable</span>
                            )
                          ) : (
                            <span>{attributeMap['Monster Rank B']?.status}</span>
                          )}
                        </span>
                        <span>|</span>
                        <span className="value-text text-left">
                          {attributeMap['Monster Rank B']?.value ?? 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={12} className="mb-3 text-[16px]">
                  {attributeMap['Monster Rank A']?.value !== null && (
                    <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_rank_a')}</div>
                  )}
                </Col>
                <Col span={12} className="mb-3 text-end flex justify-end items-center">
                  {attributeMap['Monster Rank A']?.value !== null && (
                    <div className="font__M__plus font-medium flex items-center w-full">
                      <div className="flex items-center gap-1 ml-auto">
                        <span className="status-text text-right pr-0">
                          {attributeMap['Monster Rank A']?.status === "Claimable" ? (
                            isOwner ? (
                              <ClaimButton
                                onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Rank A'))}
                                disabled={claimingRanks.has(getRank('Monster Rank A'))}
                              />
                            ) : (
                              <span className="claimable">Claimable</span>
                            )
                          ) : (
                            <span>{attributeMap['Monster Rank A']?.status}</span>
                          )}
                        </span>
                        <span>|</span>
                        <span className="value-text text-left">
                          {attributeMap['Monster Rank A']?.value ?? 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={12} className="mb-3 text-[16px]">
                  {attributeMap['Monster Regeneration 1']?.value !== null && (
                    <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_regeneration_1')}</div>
                  )}
                </Col>
                <Col span={12} className="mb-3 text-end flex justify-end items-center">
                  {attributeMap['Monster Regeneration 1']?.value !== null && (
                    <div className="font__M__plus font-medium flex items-center w-full">
                      <div className="flex items-center gap-1 ml-auto">
                        <span className="status-text text-right pr-0">
                          {attributeMap['Monster Regeneration 1']?.status === "Claimable" ? (
                            isOwner ? (
                              <ClaimButton
                                onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Regeneration 1'))}
                                disabled={claimingRanks.has(getRank('Monster Regeneration 1'))}
                              />
                            ) : (
                              <span className="claimable">Claimable</span>
                            )
                          ) : (
                            <span>{attributeMap['Monster Regeneration 1']?.status}</span>
                          )}
                        </span>
                        <span>|</span>
                        <span className="value-text text-left">
                          {attributeMap['Monster Regeneration 1']?.value ?? 'N/A'}
                        </span>
                      </div>
                    </div>
                  )}
                </Col>
              </Row>
                </div>
                <div className="bg-[#020f38] py-[16px] px-[24px] min-h-[142px] rounded-[8px]">
                  <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Monster Regeneration 2']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_regeneration_2')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Monster Regeneration 2']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Monster Regeneration 2']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Regeneration 2'))}
                                  disabled={claimingRanks.has(getRank('Monster Regeneration 2'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Monster Regeneration 2']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Monster Regeneration 2']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Monster Regeneration 3']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_regeneration_3')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Monster Regeneration 3']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Monster Regeneration 3']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Regeneration 3'))}
                                  disabled={claimingRanks.has(getRank('Monster Regeneration 3'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Monster Regeneration 3']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Monster Regeneration 3']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Monster Fusion 1']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_fusion_1')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Monster Fusion 1']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Monster Fusion 1']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Fusion 1'))}
                                  disabled={claimingRanks.has(getRank('Monster Fusion 1'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Monster Fusion 1']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Monster Fusion 1']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Monster Fusion 2']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.monster_fusion_2')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Monster Fusion 2']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Monster Fusion 2']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Monster Fusion 2'))}
                                  disabled={claimingRanks.has(getRank('Monster Fusion 2'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Monster Fusion 2']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Monster Fusion 2']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Coach 1']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.coach_1')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Coach 1']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Coach 1']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Coach 1'))}
                                  disabled={claimingRanks.has(getRank('Coach 1'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Coach 1']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Coach 1']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Coach 2']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.coach_2')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Coach 2']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Coach 2']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Coach 2'))}
                                  disabled={claimingRanks.has(getRank('Coach 2'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Coach 2']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Coach 2']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Crystallization 1']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.crystallization_1')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Crystallization 1']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Crystallization 1']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Crystallization 1'))}
                                  disabled={claimingRanks.has(getRank('Crystallization 1'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Crystallization 1']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Crystallization 1']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Crystallization 2']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.crystallization_2')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Crystallization 2']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Crystallization 2']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Crystallization 2'))}
                                  disabled={claimingRanks.has(getRank('Crystallization 2'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Crystallization 2']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Crystallization 2']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Ranked Match 1']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.ranked_match_1')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Ranked Match 1']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Ranked Match 1']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Ranked Match 1'))}
                                  disabled={claimingRanks.has(getRank('Ranked Match 1'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Ranked Match 1']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Ranked Match 1']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Ranked Match 5']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.ranked_match_5')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Ranked Match 5']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Ranked Match 5']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Ranked Match 5'))}
                                  disabled={claimingRanks.has(getRank('Ranked Match 5'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Ranked Match 5']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Ranked Match 5']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Ranked Match 10']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.ranked_match_10')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Ranked Match 10']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Ranked Match 10']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Ranked Match 10'))}
                                  disabled={claimingRanks.has(getRank('Ranked Match 10'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Ranked Match 10']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Ranked Match 10']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Exploration 1']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.exploration_1')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Exploration 1']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Exploration 1']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Exploration 1'))}
                                  disabled={claimingRanks.has(getRank('Exploration 1'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Exploration 1']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Exploration 1']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Exploration 5']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.exploration_5')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Exploration 5']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Exploration 5']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Exploration 5'))}
                                  disabled={claimingRanks.has(getRank('Exploration 5'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Exploration 5']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Exploration 5']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col span={12} className="mb-3 text-[16px]">
                    {attributeMap['Exploration 10']?.value !== null && (
                      <div className="font__M__plus font-bold">{t('hashNFTDetail.exploration_10')}</div>
                    )}
                  </Col>
                  <Col span={12} className="mb-3 text-end flex justify-end items-center">
                    {attributeMap['Exploration 10']?.value !== null && (
                      <div className="font__M__plus font-medium flex items-center w-full">
                        <div className="flex items-center gap-1 ml-auto">
                          <span className="status-text text-right pr-0">
                            {attributeMap['Exploration 10']?.status === "Claimable" ? (
                              isOwner ? (
                                <ClaimButton
                                  onClaim={() => handleClaim(monsterDetail?.tokenId, getRank('Exploration 10'))}
                                  disabled={claimingRanks.has(getRank('Exploration 10'))}
                                />
                              ) : (
                                <span className="claimable">Claimable</span>
                              )
                            ) : (
                              <span>{attributeMap['Exploration 10']?.status}</span>
                            )}
                          </span>
                          <span>|</span>
                          <span className="value-text text-left">
                            {attributeMap['Exploration 10']?.value ?? 'N/A'}
                          </span>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
              <ClaimFailModal
                actions={{
                  isModalOpen: isClaimFailModalOpen,
                  handleCancel: handleCancel,
                  handleConfirm: handleCancel,
                }}
                t={t}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <Row>
            <Col span={12} className="text-[16px]">
              <div className="mb-3 font__M__plus font-bold">{t('hashNFTDetail.ID')}</div>
              {monsterDetail?.main_seed && (
                <div className="mb-3 font__M__plus font-bold">{t('hashNFTDetail.name')}</div>
              )}
              {monsterDetail?.name && monsterDetail?.asset === 'HASH CHIP NFT' && (
                <div className="mb-3 font__M__plus font-bold">{t('hashNFTDetail.name')}</div>
              )}
              {monsterDetail?.description && (
                <div className="mb-3 font__M__plus font-bold">{t('hashNFTDetail.description')}</div>
              )}
            </Col>
            <Col span={12} className="text-end">
              <div className="mb-3 font__M__plus font-medium">
                <a
                  style={{ color: '#40A9FF' }}
                  href={`${configs.NETWORK.scan}token/${
                    monsterDetail?.contractAddress ??
                    (monsterDetail?.type_name === 'General Hash'
                      ? configs.ADDRESS_GENERAL
                      : configs.ADDRESS_GENESIS)
                  }/instance/${monsterDetail?.tokenId}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {monsterDetail?.tokenId}
                </a>
              </div>
              {monsterDetail?.main_seed && (
                <div className="mb-3 font__M__plus font-medium">
                  {monsterDetail?.type_name} [{monsterDetail?.main_seed}]
                </div>
              )}
              {monsterDetail?.name && monsterDetail?.asset === 'HASH CHIP NFT' && (
                <div className="mb-3 font__M__plus font-medium">{monsterDetail?.name}</div>
              )}
              {monsterDetail?.description && (
                <div
                  className="mb-3 font__M__plus font-medium"
                  dangerouslySetInnerHTML={{ __html: descriptionContent }}
                ></div>
              )}
            </Col>
          </Row>
          {monsterDetail?.timesRegeneration !== undefined && (
            <Row>
              <Col span={12} className="text-[16px]">
                <div className="mb-3 font__M__plus font-bold">{t('hashNFTDetail.regenerationCount')}</div>
                <div className="mb-3 font__M__plus font-bold">{t('hashNFTDetail.remainingRegeneration')}</div>
              </Col>
              <Col span={12} className="text-end">
                <div 
                  className="mb-3 font__M__plus font-medium" 
                  style={{ color: getRegenerationColor(monsterDetail?.type_name, regenerationCount) }}
                >
                  {regenerationCount}/{maxRegeneration[monsterDetail?.type_name]}
                </div>
                <div className="mb-3 font__M__plus font-medium">{remainingRegeneration}</div>
              </Col>
            </Row>
          )}
          {monsterDetail?.timesRegeneration === undefined && (
            <Row>
              <Col span={12} className="text-[16px]">
                <div className="mb-3 font__M__plus font-bold">{t('hashNFTDetail.regenerationCount')}</div>
              </Col>
              <Col span={12} className="text-end">
                <div className="mb-3 font__M__plus font-medium">0/1</div>
              </Col>
            </Row>
          )}
          <Row>
            <Col span={12} className="text-[16px]">
              {monsterDetail?.main_seed && (
                <div className="font__M__plus font-bold">{t('hashNFTDetail.mainSeed')}</div>
              )}
            </Col>
            <Col span={12} className="text-end">
              {monsterDetail?.main_seed && (
                <div className="font__M__plus font-medium">{monsterDetail?.main_seed}</div>
              )}
            </Col>
          </Row>
          <ClaimFailModal
            actions={{
              isModalOpen: isClaimFailModalOpen,
              handleCancel: handleCancel,
              handleConfirm: handleCancel,
            }}
            t={t}
          />
        </>
      )}
    </Card>
  );
};